import React from 'react';
import { array, bool, func, object } from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import ContactsTableRowMenu from './ContactsTableRowMenu';

import classes from './ContactsTable.module.css';

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: '#f4f4f4',
        }
    }
}))(TableRow);

const ContactsTable = ({
    contacts,
    companyInfo,
    isFullArchitectAllowed,
    onToggleDeleteContactModal,
    onToggleEditContactModal,
    onSort,
    order,
    orderBy,
    ...props
}) => {
    const isSortedByName = orderBy === 'name';
    const sortDirection = isSortedByName ? order : false;

    return (
        <Table className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell
                        className={classes.headerCell}
                        sortDirection={sortDirection}
                        onClick={onSort('name')}
                    >
                        <Tooltip
                            title={
                                <span className={classes.tooltip}>
                                    Sort
                                </span>
                            }
                            placement="top-start"
                        >
                            <TableSortLabel
                                active={isSortedByName}
                                direction={order}
                            >
                                Name
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>
                    <TableCell className={classes.headerCell}>
                        Title
                    </TableCell>
                    <TableCell padding="none" />
                </TableRow>
            </TableHead>
            <TableBody>
                {contacts.map(contact =>
                    <StyledTableRow key={contact.id}>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {contact.name}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{contact.name}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell className={`${classes.dataCell} ${classes.ellipseCell}`}>
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        {contact.title}
                                    </span>
                                }
                                placement="top-start"
                            >
                                <span>{contact.title}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell
                            className={classes.rowMenuCell}
                            padding="none"
                        >
                            <ContactsTableRowMenu
                                contact={contact}
                                companyInfo={companyInfo}
                                hidden={!isFullArchitectAllowed}
                                onToggleDeleteContactModal={onToggleDeleteContactModal}
                                onToggleEditContactModal={onToggleEditContactModal}
                            />
                        </TableCell>
                    </StyledTableRow>
                )}
            </TableBody>
        </Table>
    );
};

ContactsTable.defaultProps = {
    isFullArchitectAllowed:     true,
    onSort:                     () => {},
    onToggleDeleteContactModal: () => {},
    onToggleEditContactModal:   () => {}
};

ContactsTable.propTypes = {
    contacts:                   array.isRequired,
    companyInfo:                object,
    isFullArchitectAllowed:     bool,
    onSort:                     func,
    onToggleDeleteContactModal: func,
    onToggleEditContactModal:   func
};

export default ContactsTable;
